(ns nl.mediquest.ui.sticky-event
  "Inspired by: https://developer.chrome.com/blog/sticky-headers/
  This will create a wrapper container with a sticky position
  NOTE: to make it actually stick, a top has to be set

  A system to apply css styling when the node \"gets stuck\" is implemented
  with a sentinel and an IntersectionObserver.
  The sentinel is a non-sticky empty dom node sitting right above the sticky
  container. An IntersectionObserver is registered on the sentinel with root as
  the first ancestor with scroll context and threshold of `[0]` (by default).

  The IntersectionObserver watches whether the sentinel is intersecting the root.
  If yes: the sticky sibling is not stuck and the attribute is removed.
  Otherwise: the sticky sibling is stuck and the attribute gets set on it.

  More info:
  - [IntersectionObserver](https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API)")

(defn- stuck-observer-callback
  [^js records _]
  (doseq [^js record records]
    (when-let [stickyTarget (.. record -target -nextElementSibling)]
      (if (.-isIntersecting record)
        (.removeAttribute stickyTarget "stuck")
        (.setAttribute stickyTarget "stuck" true)))))

(def ^js ^:private stuck-observer
  (js/IntersectionObserver.
   stuck-observer-callback
   #js {}))

(defn- get-attr-and-children
  [[maybe-attr & children :as all-children]]
  (if (map? maybe-attr)
    [maybe-attr children]
    [{} all-children]))

(defn sticky
  [& args]
  (let [[attr children] (get-attr-and-children args)]
    [:<>
     [:div {:ref #(when % (.observe stuck-observer %))}]
     (into
      [:div.sticky attr]
      children)]))
